import React from 'react';
import {connect} from 'react-redux';

import Notifications from './lib/Notifications';
import * as notify from './actions';
import * as actionTypes from './actionTypes';
import * as reducer from './reducer';

const NotifyService = connect(
	state => ({notifications: state.get('notifications')}),
	dispatch => ({dispatch}))(({dispatch, notifications}) => {
	const onRemove = uid => {
		dispatch(notify.hide(uid));
	};

	return (
		<Notifications
			onRemove={onRemove}
			notifications={notifications}
		/>
	);
});

export {notify, actionTypes, reducer, NotifyService};



// WEBPACK FOOTER //
// ./src/common/notify/index.js